import { Text, Modal, Button, ScrollView, VStack } from 'native-base';
import React from 'react';
import { useDoctorCustomerRequests } from '../../DoctorCustomer/hooks/useDoctorCustomerRequests';
import Loading from '../../Common/components/Loading';
import { useTimezones } from '../../Common/hooks/useTimezones';
import { useDoctorCustomerLookup } from '../../DoctorCustomer/hooks/useDoctorCustomerLookup';

export function SendBookingLink({
  customerId,
  setMessage,
  close,
}: {
  customerId: string;
  setMessage: (message: string | null) => void;
  close: () => void;
}) {
  const { customer } = useDoctorCustomerLookup(customerId);
  const { loading, requestsDescOrder } = useDoctorCustomerRequests(customerId);

  const { convertUTCDateToUserISO } = useTimezones();

  const generateLink = (id: string) => {
    if (customer?.brand === 'leafdoctors') return `https://patients.leafdoctors.com.au/book/${id}`;

    return null;
  };

  const onPress = (id: string) => {
    const url = generateLink(id);

    setMessage(`Book your appointment using this link: ${url}`);
  };

  return (
    <Modal isOpen={true}>
      <Modal.Content>
        <Modal.CloseButton onPress={close} />
        <Modal.Header>Send Booking Link</Modal.Header>
        <Modal.Body>
          <Text mb={2}>Select the request related to the booking. Newest on top:</Text>

          {loading && <Loading />}

          <ScrollView maxH={300}>
            <VStack space={2}>
              {!loading &&
                requestsDescOrder?.map((a) => (
                  <Button onPress={() => onPress(a?.id)} variant={'outline'} size={'sm'}>
                    {`${a?.serviceTier?.name} - ${convertUTCDateToUserISO(a?.requestedAt)?.format(
                      'DD/MM/YYYY',
                    )}`}
                  </Button>
                ))}
            </VStack>
          </ScrollView>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
}
